module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-adults-bd9f191a22c5883f47384a39a3db3c98.webp";